class RechargeWidget {
    constructor() {
        this.observeForRadioButtons(() => {
          this.forceOnetimeDefault();                  // ✅ Apply default based on product
          this.initObserver();                         // Watch DOM updates
          this.initPurchaseOptionToggle();             // Handle UI + state toggle
          this.initSellingPlanButtons();               // Set up plan selection
        });
      }
      
      
      waitForRechargeWidget(callback) {
        const observer = new MutationObserver((mutations, obs) => {
          const rechargeWidgetReady = document.querySelector(".rc-selling-plans-dropdown__select");
          if (rechargeWidgetReady) {
            obs.disconnect();
            callback();
          }
        });
      
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
      
      updateAtcPrice() {
        const priceElement = document.querySelector('#atc-price [js-normal-price]');
        const compareElement = document.querySelector('#atc-price [js-compare-price]');
      
        const subscriptionRadio = document.querySelector("input[name='purchaseOption'][value='subscription']");
        const onetimeRadio = document.querySelector("input[name='purchaseOption'][value='onetime']");
      
        if (subscriptionRadio?.checked) {
          const subscriptionLabel = subscriptionRadio.closest('label');
          const originalPrice = subscriptionLabel?.querySelector('.subs-original-price')?.textContent?.trim(); // $31
          const comparePrice = subscriptionLabel?.querySelector('.subs-compare-price')?.textContent?.trim();   // $39
      
          if (priceElement) priceElement.textContent = originalPrice || '';
          if (compareElement) compareElement.textContent = comparePrice || '';
        }
      
        if (onetimeRadio?.checked) {
          const onetimeLabel = onetimeRadio.closest('label');
          const comparePrice = onetimeLabel?.querySelector('.compare-price')?.textContent?.trim(); // $31
      
          if (priceElement) priceElement.textContent = comparePrice || '';
          if (compareElement) compareElement.textContent = '';
        }
      }
      
      

    setSellingPlanFromDropdown() {
        const dropdown = document.querySelector('.rc-selling-plans-dropdown__select');
        const sellingPlanId = dropdown?.value;
      
        if (!sellingPlanId) return;
      
        const addToCartForm = document.querySelector("form[action='/cart/add']");
        if (!addToCartForm) return;
      
        let planInput = addToCartForm.querySelector("input[name='selling_plan']");
        if (!planInput) {
          planInput = document.createElement('input');
          planInput.type = 'hidden';
          planInput.name = 'selling_plan';
          addToCartForm.appendChild(planInput);
        }
      
        planInput.value = sellingPlanId;
      }
      

    observeForRadioButtons(callback) {
        const observer = new MutationObserver((mutations, obs) => {
            const subscriptionRadio = document.querySelector("input[name='purchaseOption'][value='subscription']");
            const onetimeRadio = document.querySelector("input[name='purchaseOption'][value='onetime']");
    
            if (subscriptionRadio && onetimeRadio) {
                obs.disconnect(); // ✅ Stop observing once both radios are available
                callback();
            }
        });
    
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    
    forceOnetimeDefault() {
        const path = window.location.pathname;
        const isSunscreenProduct = path.includes('/products/sunscreen');
        const subscriptionRadio = document.querySelector("input[name='purchaseOption'][value='subscription']");
        const onetimeRadio = document.querySelector("input[name='purchaseOption'][value='onetime']");
      
        if (!subscriptionRadio || !onetimeRadio) return;
      
        if (isSunscreenProduct) {
          // Force One-time for sunscreen
          subscriptionRadio.checked = false;
          onetimeRadio.checked = true;
        } else {
          // Default to subscription for all other products
          onetimeRadio.checked = false;
          subscriptionRadio.checked = true;
        }
      }
      
    
    

    initObserver() {
        const observer = new MutationObserver((mutationsList, observer) => {
            const firstLabel = document.querySelector('.rc-template__radio label.rc-radio');
            const sellingPlansDiv = document.querySelector('.rc-selling-plans');
            const widgetWrapper = document.querySelector('.rc-widget');
            const subscriptionText = document.querySelector('.rc-radio__subscription');
            const subscriptionElement = document.querySelector('.rc-radio__label');
            const subscriptionOptions = document.querySelectorAll('.rc-selling-plans-dropdown__select option');
         
            const subscriptionRadio = document.querySelector(".rc-radio input[type='radio']");
            const customSubscriptionOptions = document.getElementById("custom-subscription-options");
            const subscriptionHeading = document.querySelector(".rc-section-heading");
            const onetimeElement = document.querySelector('.onetime-radio .rc-radio__label');
            const oneTimePrice = customSubscriptionOptions?.getAttribute('data-onetime-price');
            const oneTimeUnit = customSubscriptionOptions?.getAttribute('data-per-day-price');
            const subsPriceElement = document.querySelector('.subscription-radio .rc-radio__price');
            const oneTimeComparePrice = document.querySelector('[js-atc-price]').getAttribute('data-variant-compare-price');
            const oneTimePriceNormal = document.querySelector('[js-atc-price]').getAttribute('data-variant-price');

          
          
            if (firstLabel && sellingPlansDiv && widgetWrapper) {
                observer.disconnect();
                this.addIntroParagraph(widgetWrapper);
                this.wrapElements(firstLabel, sellingPlansDiv);
                this.populateFrequencyOptions(subscriptionOptions);
                this.setupSubscriptionToggle(subscriptionRadio, customSubscriptionOptions, subscriptionHeading);
               this.updateWidgetPrice();
               // Trigger change on the selected option if user hasn't changed it manually
                const defaultDropdown = document.querySelector('.rc-selling-plans-dropdown__select');
                if (defaultDropdown) {
                const selectedOption = defaultDropdown.options[defaultDropdown.selectedIndex];
                selectedOption.dispatchEvent(new Event("change", { bubbles: true }));
                }


                this.bindFrequenyChangeEvent();
            }

            if (subscriptionText) {
                const text = subscriptionText.textContent;
                const saveText = text.match(/save\s\d+%/i)?.[0] || '';
                const cleanText = text.replace('&', '').replace(saveText, '').trim();
                subscriptionText.textContent = 'Subscribe and save';
                const saveSpan = document.createElement('span');
                saveSpan.classList.add('rc-save');
                if (saveText == '') {
                    saveSpan.style.display = 'none';
                }
                saveSpan.textContent = saveText;
                subscriptionElement.appendChild(document.createTextNode(' '));
                subscriptionElement.appendChild(saveSpan);
            }

            if(onetimeElement) {
                //const subsPrices = subsPriceElement.textContent.trim();
                const numericPrices = parseFloat(oneTimePriceNormal.replace(/[^0-9.]/g, '')); // => 35
                const dividedPrices = numericPrices / 30;
              // <div class="unit-price">${oneTimeUnit}</div>
                let oneTimeHTML = `<div class="onetime-text-wrapper">
                <div class="text">One-time purchase</div>
                <div class="unit-price">$${dividedPrices.toFixed(2)} / day</div>
                </div><div class="onetime-price-wrapper"><span class="regular-price">${oneTimeComparePrice}</span><span class="compare-price">${oneTimePriceNormal}</span></div>`;
                onetimeElement.innerHTML = oneTimeHTML;
            }

            if(subsPriceElement) {
              const subsPrice = subsPriceElement.textContent.trim();
              if(oneTimePrice == subsPrice){
                subsPriceElement.innerHTML = `<span class="subs-original-price">${subsPrice}</span>`;
              }
              else{
              subsPriceElement.innerHTML = `<span class="subs-compare-price">${oneTimePrice}</span><span class="subs-original-price">${subsPrice}</span>`;  
              }
              
              
              const numericPrice = parseFloat(subsPrice.replace(/[^0-9.]/g, '')); // => 35
              const dividedPrice = numericPrice / 30;

              if (subscriptionText) {
                  subscriptionText.innerHTML = `<div class="subs-text">Subscribe and save</div><div class="subs-unit-price">$${dividedPrice.toFixed(2)} / day</div>`;
               }
              
            }

         
            
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }


  bindFrequenyChangeEvent() {
      const frequencyDropdowns = document.querySelectorAll('.rc-selling-plans-dropdown__select');
      if(frequencyDropdowns.length > 0) {
         frequencyDropdowns.forEach((dropdown)=> {
           const sellingInputSticky = document.querySelector('[js-sticky-selling-plan]');
           if(sellingInputSticky) sellingInputSticky.value = dropdown.value;
           dropdown.addEventListener("change",  (event)=> {
             if(sellingInputSticky) sellingInputSticky.value = dropdown.value;
           });
         });
      }
  }
  
   updateWidgetPrice() {
        const oneTimePriceContainer = document.querySelector(".rc-widget .onetime-radio .onetime-price-wrapper");
        const subsPriceContainer = document.querySelector(".rc-widget .subscription-radio .rc-radio__price");
        const subsPrice = document.querySelector('.rc-widget .rc-radio.subscription-radio .rc-radio__price')?.textContent;
        const oneTimePrice = document.querySelector('[js-atc-price]').getAttribute('data-variant-price');
        const oneTimePriceWithoutDiscount = document.querySelector('[js-atc-price]').getAttribute('data-variant-without-discount-price');
        const oneTimeComparePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-compare-price');
         if(oneTimePriceContainer) {
            oneTimePriceContainer.innerHTML = `One-time purchase <span class="original">${oneTimePrice}</span><span class="compare">${oneTimeComparePrice}</span>`;
         }
        // if(subsPriceContainer) {
        //     subsPriceContainer.innerHTML = `<span class="original">${subsPrice}</span><span class="compare">${oneTimePriceWithoutDiscount}</span>`;
        // }
    }
  
  setupSubscriptionToggle(subscriptionRadio, customSubscriptionOptions, subscriptionHeading) {
        if (!subscriptionRadio || !customSubscriptionOptions || !subscriptionHeading) return;
    
        const oneTimeRadio = document.querySelector(".onetime-radio input[type='radio']");
        const subsPrice = document.querySelector('.rc-widget .rc-radio.subscription-radio .rc-radio__price')?.textContent;
    
        const toggleVisibility = () => {

          const oneTimePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-price');
          const oneTimePriceWithoutDiscount = document.querySelector('[js-atc-price]').getAttribute('data-variant-without-discount-price');
          const oneTimeComparePrice =  document.querySelector('[js-atc-price]').getAttribute('data-variant-compare-price');
          const regularPriceContainers = document.querySelectorAll('[js-normal-price]');
          const comparePriceContainers = document.querySelectorAll('[js-compare-price]');
          const sellingInputSticky = document.querySelector('[js-sticky-selling-plan]');
          
            if (subscriptionRadio.checked) {
                customSubscriptionOptions.style.display = "flex";
                subscriptionHeading.style.display = "block";
                this.updateSellingPlanSelection();
                if(typeof updateSubscription != 'undefined') updateSubscription('subscription');
                if(subsPrice) {
                    regularPriceContainers.forEach((regularPriceContainer)=>{
                        regularPriceContainer.classList.add('texts')
                      regularPriceContainer.innerHTML = subsPrice;
                    });
                   comparePriceContainers.forEach((comparePriceContainer)=>{
                      comparePriceContainer.innerHTML = oneTimePriceWithoutDiscount;
                      console.log(oneTimePriceWithoutDiscount)
                   });
                }

                if(sellingInputSticky) sellingInputSticky.setAttribute('name', 'selling_plan');
              this.bindFrequenyChangeEvent();
              
            } else {
                customSubscriptionOptions.style.display = "none";
                subscriptionHeading.style.display = "none";
                regularPriceContainers.forEach((regularPriceContainer)=>{
                   regularPriceContainer.innerHTML = oneTimePrice;
               });
                comparePriceContainers.forEach((comparePriceContainer)=>{
                   comparePriceContainer.innerHTML = oneTimeComparePrice;
               });
                if(typeof updateSubscription != 'undefined') updateSubscription('onetime');

                if(sellingInputSticky) sellingInputSticky.removeAttribute('name');
                this.bindFrequenyChangeEvent();
            }
        };

        toggleVisibility();
        subscriptionRadio.addEventListener("change", toggleVisibility);
        if (oneTimeRadio) {
            oneTimeRadio.addEventListener("change", toggleVisibility);
        }
    }

    populateFrequencyOptions(subscriptionOptions) {
        const customContainer = document.getElementById("custom-subscription-options");
        if (!customContainer) return;
    
        subscriptionOptions.forEach(option => {
            const button = document.createElement("button");
            button.textContent = option.textContent.trim();
            button.classList.add("subscription-button");
            button.dataset.value = option.value;
    
            if (option.selected) {
                button.classList.add("active");
            }
    
            button.addEventListener("click", function () {
                subscriptionOptions.forEach(opt => opt.selected = false);
                option.selected = true;
                option.dispatchEvent(new Event("change", { bubbles: true }));
                document.querySelectorAll(".subscription-button").forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
            });
    
            customContainer.appendChild(button);
        });
    }    
        
    addIntroParagraph(widgetWrapper) {
        const introParagraph = document.createElement('div');
        introParagraph.textContent = window.rechargeSectionHeading;
        introParagraph.classList.add('rc-section-heading');
        widgetWrapper.parentNode.insertBefore(introParagraph, widgetWrapper);
    }

    wrapElements(firstLabel, sellingPlansDiv) {
      
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('rc-widget-wrapper');
        firstLabel.parentNode.insertBefore(wrapperDiv, firstLabel);
        wrapperDiv.appendChild(firstLabel);
        const deliveryPlansWrapper = document.createElement('div');
        deliveryPlansWrapper.classList.add('rc-delivery-plans-wrapper');
        const paragraph = document.createElement('p');
        paragraph.innerHTML = window.rechargeProductDescription;
        paragraph.classList.add('rc-delivery-info');
        deliveryPlansWrapper.appendChild(paragraph);
        deliveryPlansWrapper.appendChild(sellingPlansDiv);
        wrapperDiv.appendChild(deliveryPlansWrapper);
    }

    initPurchaseOptionToggle() {
        const subscriptionRadio = document.querySelector("input[name='purchaseOption'][value='subscription']");
        const onetimeRadio = document.querySelector("input[name='purchaseOption'][value='onetime']");
    
        const subscribeSection = document.querySelector("input[name='purchaseOption'][value='subscription']")?.closest("label");
        const onetimeSection = document.querySelector("input[name='purchaseOption'][value='onetime']")?.closest("label");
        const frequencyContainer = document.querySelector(".selling-plan-buttons");
        const frequencyContainerHeading = document.querySelector(".rc-section-heading");
    
        const togglePurchaseSections = () => {
            if (subscriptionRadio && subscriptionRadio.checked) {
                if (frequencyContainer && frequencyContainerHeading) {
                    frequencyContainer.setAttribute("style", "display: flex !important;");
                    frequencyContainerHeading.setAttribute("style", "display: block !important;");
                }
                if (subscribeSection) {
                    subscribeSection.classList.add("rc-radio--active");
                }
                if (onetimeSection) {
                    onetimeSection.classList.remove("rc-radio--active");
                }
                this.updateSellingPlanSelection();
                this.setSellingPlanFromDropdown();

            } else if (onetimeRadio && onetimeRadio.checked) {
                if (frequencyContainer && frequencyContainerHeading) {
                    frequencyContainer.style.display = "none";
                    frequencyContainerHeading.style.display = "none";
                }
                if (onetimeSection) {
                    onetimeSection.classList.add("rc-radio--active");
                }
                if (subscribeSection) {
                    subscribeSection.classList.remove("rc-radio--active");
                }
                this.updateOnetimeSelection();
            }
            this.updateAtcPrice(); // Update price display based on selected plan
        };
    
        if (subscriptionRadio) {
            subscriptionRadio.addEventListener("change", togglePurchaseSections);
        }
        if (onetimeRadio) {
            onetimeRadio.addEventListener("change", togglePurchaseSections);
        }
    
        if (subscribeSection) {
            subscribeSection.addEventListener("click", () => {
                if (subscriptionRadio) subscriptionRadio.checked = true;
                togglePurchaseSections();
            });
        }
        if (onetimeSection) {
            onetimeSection.addEventListener("click", () => {
                if (onetimeRadio) onetimeRadio.checked = true;
                togglePurchaseSections();
            });
        }
        togglePurchaseSections();
        this.setupSubscriptionToggle(subscriptionRadio, frequencyContainer, frequencyContainerHeading);

    }

    updateSellingPlanSelection() {
    
        const newSPContainer = document.querySelector(".selling-plan-buttons");
        if (!newSPContainer) return;
    
        // ✅ Always force-select first selling plan if none is active
        let activeButton = newSPContainer.querySelector(".selling-plan-button.active");
        if (!activeButton) {
            activeButton = newSPContainer.querySelector(".selling-plan-button");
            if (activeButton) {
                newSPContainer.querySelectorAll(".selling-plan-button").forEach(btn => btn.classList.remove("active"));
                activeButton.classList.add("active");
            }
        }
    
        if (!activeButton) return;
    
        // ✅ Always set the hidden selling_plan input
        const newSellingPlanValue = activeButton.getAttribute("data-selling-plan-id");
        const newProductId = activeButton.getAttribute("data-subscription-product-id");
        const newProductType = activeButton.getAttribute("data-subscription-product-type");
    
        const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
        if (addToCartForm) {
            let newSPInput = addToCartForm.querySelector("input[name='selling_plan']");
            let productIdInput = addToCartForm.querySelector("input[name='id']");
            let newProductTypeInput = addToCartForm.querySelector("input[name='type']");
    
            if (!newSPInput) {
                newSPInput = document.createElement("input");
                newSPInput.type = "hidden";
                newSPInput.name = "selling_plan";
                addToCartForm.appendChild(newSPInput);
            }
            newSPInput.value = newSellingPlanValue;
    
            if (productIdInput) {
                productIdInput.value = newProductId;
            }
    
            if (newProductTypeInput) {
                newProductTypeInput.value = newProductType;
            }
        }
    }
    

    updateOnetimeSelection() {
     
        const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
        const initialProductType = document.querySelector('#onetimePurchaseSection')?.getAttribute('data-product-type');
        if (addToCartForm) {
            let productIdInput = addToCartForm.querySelector("input[name='id']");
            let spInput = addToCartForm.querySelector("input[name='selling_plan']");
            let productTypeInput = addToCartForm.querySelector("input[name='type']");
          
            if (!productIdInput) {
                productIdInput = document.createElement("input");
                productIdInput.type = "hidden";
                productIdInput.name = "id";
                addToCartForm.appendChild(productIdInput);
            }
            productIdInput.value = window.mainProductVariant || "";
            if (spInput) {
                spInput.value = "";
            }
            if (productTypeInput) {
                productTypeInput.value = initialProductType;
            }
        }
    }

    initSellingPlanButtons() {
        const newSPContainer = document.querySelector(".selling-plan-buttons");
        if (!newSPContainer) return;
    
        newSPContainer.querySelectorAll(".selling-plan-button").forEach(button => {
            button.addEventListener("click", () => {
                newSPContainer.querySelectorAll(".selling-plan-button").forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
    
                const newSellingPlanValue = button.getAttribute("data-selling-plan-id");
                const newProductId = button.getAttribute("data-subscription-product-id");
                const addToCartForm = document.querySelector("product-form form[action='/cart/add']");
                if (addToCartForm) {
                    let newSPInput = addToCartForm.querySelector("input[name='selling_plan']");
                    let productIdInput = addToCartForm.querySelector("input[name='id']");
                    if (!newSPInput) {
                        newSPInput = document.createElement("input");
                        newSPInput.type = "hidden";
                        newSPInput.name = "selling_plan";
                        addToCartForm.appendChild(newSPInput);
                    }
                    newSPInput.value = newSellingPlanValue;
                    if (productIdInput) {
                        productIdInput.value = newProductId;
                    }
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new RechargeWidget();
});
